import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {
  darkBlue,
  gray2,
  green,
  imac13inMax,
  lightBlue, lightGray2,
  marketingMobileCuttoff,
  white
} from "@css/constants";
import {backgroundImageStyle, fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";
import {Button} from "@components/Button";

export type RoadmapSectionImageProps = {
  imageUrl: string
}

export type DotProps = {
  color: string
}

export const RoadmapSectionContainer = styled('div')(css`
  display: flex;
  flex-direction: column;
  padding-top: 38px;
  background-color: ${darkBlue};

  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: column;
    padding-top: 40px;
  }
`)

export const RoadmapSectionRow = styled('ul')(css`
  display: flex;
  flex-direction: row;
  margin: 0 16px 10px;
  flex-flow: wrap;
  align-self: center;
  place-content: center;
  list-style: none;
  width: 87%;

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${imac13inMax}) {
    width: 95%;
  }
  
  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: column;
    display: block;
    margin-bottom: 0;
  }
`)

export const RoadmapSectionHeader = styled('div')(css`
  height: 40px;
  
  @media(max-width: ${'331px'}) and (min-width: ${'320px'}) {
    height: 125px !important;
  }
  
  @media(max-width: ${marketingMobileCuttoff}) {
    margin-bottom: 20px;
    border-left: 10px solid ${lightBlue};
    padding-left: 15px;
    height: 84px;
  }
`)

export const RoadmapSectionHeaderTitle = styled('h3')(css`
  font-size: 32px;
  ${FontNormal(600)};
  color: ${white};
  align-self: center;
  text-align: center;
  margin-bottom: 40px;

  @media(max-width: ${marketingMobileCuttoff}) {
    text-align: initial;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 20px;
    margin-bottom: 0;
  }
`)
export const RoadmapSectionEmptyRow = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const RoadmapSectionButtonWrapper = styled.div`
  margin-bottom: 50px;
  margin-top: 40px;

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-top: 15px;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;

export const RoadmapItemWrapper = styled.div`
  display: block;
  text-align: center;
  margin: 0 25px;

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${imac13inMax}) {
    margin: 0 15px;
  }
`;

export const RoadmapItemTitle = styled.div`
  ${fontSize(22)};
  ${FontNormal(700)}
  color: ${white};

  & sup {
    bottom: 1px;
    position: relative;
    vertical-align: baseline;
  }
`;

export const RoadmapItemSubtitle = styled.div`
  ${fontSize(18)};
  ${FontNormal(400)}
  color: ${white};
`;

export const RoadmapSectionImage = styled('div')<RoadmapSectionImageProps>(props => css`
  flex-direction: column;
  display: flex;
  height: 327px;
  background-image: url(${props.imageUrl});;
  align-self: center;
  ${backgroundImageStyle};
  width: 100%;
  margin-left: 3%;
  
  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${imac13inMax}) {
    width: 90%;
    height: 280px;
  }

  @media(max-width: ${marketingMobileCuttoff}) {
    display: none;
  }
`);

export const StyledLi = styled.li`
  width: 33%;

  @media(max-width: ${marketingMobileCuttoff}) {
    display: none;
  }
`;

export const ListDots = styled.div`
  position: relative;
  width: 90%;
  display: none;
  margin-left: 28px;

  @media(max-width: ${marketingMobileCuttoff}) {
    display: block;
  }
`;

export const ListDotsProgress = styled('div') <DotProps>(props => css`
  position: absolute;
  background-color: ${(props.color === 'green') ? green : lightGray2};
  width: 2px;
  height: 59px;
  margin-top: 18px;
  margin-left: -34px;
  margin-right: 84px;
`);

export const ListDotsWrapper = styled.div`
  padding: 0;
  margin: 0;
`;

export const ListDotsClear = styled.div`
  clear: both;
`;

export const ListDotsItem = styled.div`
  position: relative;
  padding-left: 40px;
  margin-bottom: 40px;
  margin-top: 30px;
`;

export const Dot = styled('div') <DotProps>(props => css`
  position: absolute;
  width: 26px;
  height: 26px;
  left: -6px;
  top: -5px;
  background-color: ${(props.color === 'green') ? green : (props.color === 'darkgrey') ? gray2 : lightGray2};
  border-radius: 26px;
`);

export const ListDotsItemContent = styled.div`
  padding: 0;
  margin: 0;
`;

export const ListDotsItemTitle = styled.p`
  ${fontSize(16)};
  ${FontNormal(400)};
  color: ${white};
  margin-bottom: 20px;
  width: 90%;
`;

export const ShieldWhiteIcon = css`
  color: white;
  height: 17px;
  width: 16px;
  padding-left: 5px;
  padding-top: 4px;
`;
